<template>
  <v-snackbar v-model="alert_state" :timeout="5000" top>
    {{ alert_message }}
    <v-btn color="error" flat v-on:click="alert_state = false">關閉</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  computed: {
    alert_message() {
      return this.$store.state.alert_message;
    },
    alert_state: {
      get() {
        return this.$store.state.alert_state;
      },
      set(value) {
        this.$store.commit("setAlertState", value);
      },
    },
  },
};
</script>
